import { render, staticRenderFns } from "./seguro-para-automovel-detalhamento.vue?vue&type=template&id=f4aaae96&"
import script from "./seguro-para-automovel-detalhamento.vue?vue&type=script&lang=js&"
export * from "./seguro-para-automovel-detalhamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports